import React from "react";
import { Upload, Button, Checkbox, Modal } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const ACCEPTED_TYPES = [
  ".srt",
  ".vtt",
  ".scc",
  "application/x-subrip",
  "text/vtt",
  "application/x-scc",
];

interface UploadModalProps {
  open: boolean;
  onCancel: () => void;
  fileList: any[];
  setFileList: (files: any[]) => void;
  processing: boolean;
  reprocessForBleeps: boolean;
  setReprocessForBleeps: (value: boolean) => void;
  handleBeforeUpload: (file: File) => any;
  handleUpload: () => void;
  setResults: (results: any[]) => void;
  setInputFileName: (name: string | null) => void;
}

const UploadModal: React.FC<UploadModalProps> = ({
  open,
  onCancel,
  fileList,
  setFileList,
  processing,
  reprocessForBleeps,
  setReprocessForBleeps,
  handleBeforeUpload,
  handleUpload,
  setResults,
  setInputFileName,
}) => {
  return (
    <Modal
      title="Upload Caption File"
      open={open}
      onCancel={onCancel}
      footer={null}
    //   width={600}
      styles={{
        body: {
            marginTop: 16,
            minHeight: 120,
            display: 'flex',
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center"
        }
      }}
    >
      {/* <UploadRow> */}
        <Upload
          beforeUpload={handleBeforeUpload}
          fileList={fileList}
          maxCount={1}
          accept={ACCEPTED_TYPES.join(",")}
          onRemove={() => {
            setFileList([]);
            setResults([]);
            setInputFileName(null);
          }}
          showUploadList={{ showRemoveIcon: true }}
        >
          <Button icon={<UploadOutlined />} disabled={processing}>
            Choose VTT, SRT, or SCC Caption File
          </Button>
        </Upload>
        <Checkbox
          defaultChecked
          checked={reprocessForBleeps}
          onChange={e => setReprocessForBleeps(e.target.checked)}
          name="reprocess_for_bleeps"
        >
          Reprocess for Bleeps
        </Checkbox>
        <Button
          type="primary"
          loading={processing}
          onClick={handleUpload}
        >
          Process File
        </Button>
      {/* </UploadRow> */}
    </Modal>
  );
};

export default UploadModal;

